import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Testentity } from './testentity.model';
import { TestentityService } from './testentity.service';
@Injectable()
export class TestentityPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private testentityService: TestentityService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.testentityService.find(id).subscribe((testentity) => {
                testentity.myZonedDateTime = this.datePipe
                    .transform(testentity.myZonedDateTime, 'yyyy-MM-ddThh:mm');
                if (testentity.myLocalDate) {
                    testentity.myLocalDate = {
                        year: testentity.myLocalDate.getFullYear(),
                        month: testentity.myLocalDate.getMonth() + 1,
                        day: testentity.myLocalDate.getDate()
                    };
                }
                this.testentityModalRef(component, testentity);
            });
        } else {
            return this.testentityModalRef(component, new Testentity());
        }
    }

    testentityModalRef(component: Component, testentity: Testentity): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.testentity = testentity;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity-popup.service.ts